<template>
  <div>
    <v-hover
      open-delay="400"
      v-slot="{ hover }"
      class="d-none d-md-block">
      <div :class="`areaBlock__container ${dataArea.nameClass}`">
        <v-img
          :src="dataArea.nameIcon"
          width="87" height="129"
          style="cursor:pointer"
        ></v-img>
        <v-expand-transition>
          <v-card
            v-if="hover"
            class="transition-fade white--text areaBlock__card"
            :style="`border: 1px solid ${dataArea.background}; max-width: ${dataArea.width}px;`"
          >
          <v-row no-gutters :style="`background: ${dataArea.background}`" class="pa-4">
            <v-col cols="12" class="text-h6 text-center">{{dataArea.name}}</v-col>
          </v-row>
          <v-row no-gutters class="black--text text-body-2 px-4 pt-4">
            <v-col
              :cols="dataArea.col"
              v-for="(city, idx) in dataArea.countries"
              :key="idx"
              class="mb-4 pl-4 text-body-2 areaBlock__col"
              :style="styleObject"
              @click="getCountry(dataArea.slug, city.slug)"
            >{{city.name}}</v-col>
          </v-row>
          </v-card>
        </v-expand-transition>
      </div>
    </v-hover>

    <!-- Mobile -->
    <div class="d-md-none">
      <v-row no-gutters class="black--text text-body-2">
        <v-col
          :cols="12"
          v-for="(city, idx) in dataArea.countries"
          :key="idx"
          class="mt-4 text-body-2 areaBlock__col"
          :style="styleObject"
          @click="getCountry(dataArea.slug, city.slug)"
        >
        <span :style="`color: ${dataArea.background};`">{{city.name}}</span></v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AreaHover',
  computed: {
    styleObject() {
      return {
        '--color-hover': this.dataArea.background,
      };
    },
  },
  props: ['dataArea'],
  methods: {
    getCountry(countrySlug, citySlug) {
      this.$router.push({
        name: 'ranking-country',
        params: {
          country: citySlug,
          top: 10,
          countryName: citySlug
        }
      })
      window.scrollTo(0,0);
    },
  }
};
</script>
<style lang="scss">
.areaBlock__col {
  &:hover {
    color: var(--color-hover);
  }
}
</style>